import { createSlice } from '@reduxjs/toolkit';

const UserRolesSlice = createSlice({
  name: 'GetUserRolesService',
  initialState: {
    loading: false,
    data: null,
    error: null,
    success: false
  },
  reducers: {
    GetUserRolesServiceInit(state) {
      state.loading = true;
      state.error = null;
    },
    GetUserRolesServiceSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
      state.success = true
    },
    GetUserRolesServiceFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false
    },
    GetUserRolesServiceReset(state) {
      return {...state, loading: false, data: null, success:  false, error: null};
    },
  },
});

export const { 
  GetUserRolesServiceInit, 
  GetUserRolesServiceSuccess, 
  GetUserRolesServiceFailure,
  GetUserRolesServiceReset
} = UserRolesSlice.actions;

export default UserRolesSlice.reducer;
